import _ from "../../../../@lodash";

const LessonModel = (data) =>
  _.defaults(data || {}, {
    title: "",
    label: "",
    classification: "lesson",    
    progress: {
      development: 0,
      production: 0,
    },
    status: {
      development: "not_started",
      production: "not_started",
    },
    order: 0,
    user: "",
    course: "",
    pmt_id : {
      development: "", 
      production: ""
    },
    linked_lesson_list: [],
  });

export default LessonModel;
